import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "lib-trend-core";
import { ConfirmationCloseAttendanceComponent } from "./confirmation-close-attendance.component";

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    ConfirmationCloseAttendanceComponent
  ],
  exports: [
    ConfirmationCloseAttendanceComponent
  ],
})

export class ConfirmationCloseAttendanceModule { }
